import React from "react";

const TermsAndConditions = () => {
  return (
    <section className="py-12 bg-gradient-to-b from-black to-gray-900 text-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-12 border-b border-blue-500 pb-4">
          <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-500">
            Términos y Condiciones de Uso
          </h1>
          <div className="flex items-center mt-4 text-gray-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>Documento legal vigente</span>
          </div>
        </div>

        <div className="prose prose-lg prose-invert max-w-none">
          <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg border-l-4 border-blue-500">
            <h3 className="text-2xl font-semibold mb-4 text-blue-300">
              INFORMACIÓN RELEVANTE
            </h3>
            <p className="text-gray-300">
              Es requisito necesario para la adquisición de los productos que se
              ofrecen en este sitio, que lea y acepte los siguientes Términos y
              Condiciones que a continuación se redactan. El uso de nuestros
              servicios así como la compra de nuestros productos implicará que
              usted ha leído y aceptado los Términos y Condiciones de Uso en el
              presente documento.
            </p>
            <p className="mt-4 text-gray-300">
              Todos los productos que son ofrecidos por nuestro sitio web
              pudieran ser creadas, cobradas, enviadas o presentadas por una
              página web tercera y en tal caso estarían sujetas a sus propios
              Términos y Condiciones. En algunos casos, para adquirir un
              producto, será necesario el registro por parte del usuario, con
              ingreso de datos personales fidedignos y definición de una
              contraseña.
            </p>
            <p className="mt-4 text-gray-300">
              El usuario puede elegir y cambiar la clave para su acceso de
              administración de la cuenta en cualquier momento, en caso de que
              se haya registrado y que sea necesario para la compra de alguno de
              nuestros productos. Stupid Comedy no asume la
              responsabilidad en caso de que entregue dicha clave a terceros.
            </p>
            <p className="mt-4 text-gray-300">
              Todas las compras y transacciones que se lleven a cabo por medio
              de este sitio web, están sujetas a un proceso de confirmación y
              verificación, el cual podría incluir la verificación del stock y
              disponibilidad de producto, validación de la forma de pago,
              validación de la factura (en caso de existir) y el cumplimiento de
              las condiciones requeridas por el medio de pago seleccionado. En
              algunos casos puede que se requiera una verificación por medio de
              correo electrónico.
            </p>
            <p className="mt-4 text-gray-300">
              Los precios de los productos ofrecidos en esta plataforma son
              válidos solamente en las compras realizadas en este sitio web.
            </p>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                LICENCIA
              </h3>
              <p className="text-gray-300">
                Stupid Comedy a través de su sitio web concede una
                licencia para que los usuarios utilicen los productos que son
                vendidos en este sitio web de acuerdo a los Términos y
                Condiciones que se describen en este documento.
              </p>
            </div>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                USO NO AUTORIZADO
              </h3>
              <p className="text-gray-300">
                En caso de que aplique (para venta de software, templetes, u
                otro producto de diseño y programación) usted no puede colocar
                uno de nuestros productos, modificado o sin modificar, en un CD,
                sitio web o ningún otro medio y ofrecerlos para la
                redistribución o la reventa de ningún tipo.
              </p>
            </div>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                PROPIEDAD
              </h3>
              <p className="text-gray-300">
                Usted no puede declarar propiedad intelectual o exclusiva a
                ninguno de nuestros productos, modificado o sin modificar. Todos
                los productos son propiedad de los proveedores del contenido. En
                caso de que no se especifique lo contrario, nuestros productos
                se proporcionan sin ningún tipo de garantía, expresa o
                implícita. En ningún caso Stupid Comedy será responsable
                de ningún daño incluyendo, pero no limitado a, daños directos,
                indirectos, especiales, fortuitos o consecuentes u otras
                pérdidas resultantes del uso o de la imposibilidad de utilizar
                nuestros productos.
              </p>
            </div>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                POLÍTICA DE REEMBOLSO Y GARANTÍA
              </h3>
              <p className="text-gray-300 mb-4">
                En el caso de productos que sean mercancías irrevocables
                no-tangibles, no realizamos reembolsos después de que se envíe
                el producto, usted tiene la responsabilidad de entender antes de
                comprarlo. Le pedimos que lea cuidadosamente antes de comprarlo.
                Hacemos solamente excepciones con esta regla cuando la
                descripción no se ajusta al producto. Hay algunos productos que
                pudieran tener garantía y posibilidad de reembolso pero este
                será especificado al comprar el producto. En tales casos la
                garantía solo cubrirá fallas de fábrica y sólo se hará efectiva
                cuando el producto se haya usado correctamente. La garantía no
                cubre averías o daños ocasionados por uso indebido.
              </p>
              <p className="text-gray-300 mb-4">
                Los términos de la garantía están asociados a fallas de
                fabricación y funcionamiento en condiciones normales de los
                productos y sólo se harán efectivos estos términos si el equipo
                ha sido usado correctamente. Esto incluye:
              </p>
              <ul className="space-y-2 pl-6">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>
                    De acuerdo a las especificaciones técnicas indicadas para
                    cada producto.
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>
                    En condiciones ambientales acorde con las especificaciones
                    indicadas por el fabricante.
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>
                    En uso específico para la función con que fue diseñado de
                    fábrica.
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>
                    En condiciones de operación eléctricas acorde con las
                    especificaciones y tolerancias indicadas.
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                COMPROBACIÓN ANTIFRAUDE
              </h3>
              <p className="text-gray-300">
                La compra del cliente puede ser aplazada para la comprobación
                antifraude. También puede ser suspendida por más tiempo para una
                investigación más rigurosa, para evitar transacciones
                fraudulentas.
              </p>
            </div>
          </div>

          <div className="mb-10">
            <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg hover:shadow-blue-900/20 transition duration-300 border-l-4 border-blue-500">
              <h3 className="text-2xl font-semibold mb-4 text-blue-300">
                PRIVACIDAD
              </h3>
              <p className="text-gray-300 mb-4">
                Stupid Comedy garantiza que la información personal que
                usted envía cuenta con la seguridad necesaria. Los datos
                ingresados por usuario o en el caso de requerir una validación
                de los pedidos no serán entregados a terceros, salvo que deba
                ser revelada en cumplimiento a una orden judicial o
                requerimientos legales.
              </p>
              <p className="text-gray-300 mb-4">
                La suscripción a boletines de correos electrónicos publicitarios
                es voluntaria y podría ser seleccionada al momento de crear su
                cuenta.
              </p>
              <p className="text-gray-300 mb-4">
                Stupid Comedy reserva los derechos de cambiar o de
                modificar estos términos sin previo aviso.
              </p>
            </div>
          </div>

          <div className="mt-16 flex justify-center">
            <div className="bg-blue-900 bg-opacity-20 p-6 rounded-xl border border-blue-700 max-w-xl w-full">
              <div className="flex items-center justify-center mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 text-blue-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <p className="text-center text-lg">
                Al utilizar nuestros servicios, usted acepta los términos y
                condiciones establecidos en este documento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
